import { DefaultTheme } from 'styled-components';

const breakpoints: DefaultTheme['breakpoints'] = {
  mobileS: 330,
  mobileM: 400,
  mobileL: 500,
  tablet: 800,
  laptopS: 900,
  laptopM: 1100,
  laptop: 1200,
  laptopL: 1300,
  laptopLM: 1450,
  laptopXL: 1600,
  desktop: 1800,
  desktopL: 2500,
};

export default breakpoints;
